import React, { useState, useEffect } from 'react'
import { shallow } from 'zustand/shallow'

import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { addToken } from '../../contexts/airdropActionCreators'
import SettingTitle from '../kit/SettingTitle'
import ModalInputField from '../kit/ModalInputField'
import { chainsDataType, networkType } from '../../util/chainsData'
import { useRpcCountStore } from 'src/store/rpcCount'
import Button from 'src/ui/atoms/Button'
import './AddTokenModal.scss'

export default function AddTokenModal({
  showAddTokenModal,
  toggleAddTokenModal,
  chain,
  network,
  getUserTokens,
}: {
  showAddTokenModal: boolean
  toggleAddTokenModal: () => void
  chain: keyof chainsDataType
  network: networkType
  getUserTokens: () => Promise<void>
}) {
  const [tokenName, setTokenName] = useState('')
  const [tokenIdentifier, setContractAddress] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const { rpcCount, incrementRpcCount } = useRpcCountStore(
    (state) => ({ rpcCount: state.count, incrementRpcCount: state.increment }),
    shallow,
  )

  const handleAddToken = async () => {
    try {
      setIsLoading(true)
      await addToken(tokenName, tokenIdentifier, chain, network, rpcCount, incrementRpcCount)
      await getUserTokens()
      setIsLoading(false)
      toggleAddTokenModal()
    } catch (error) {
      setIsLoading(false)
      console.error(error)
    }
  }

  useEffect(() => {
    if (!showAddTokenModal) {
      setTokenName('')
      setContractAddress('')
    }
  }, [showAddTokenModal])

  return (
    <Modal
      open={showAddTokenModal}
      onClose={toggleAddTokenModal}
      aria-labelledby="update-transaction-modal"
      aria-describedby="update-transaction-modal">
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxHeight: '90%',
          width: '580px',
          maxWidth: '90%',
          background: '#181D38',
          color: '#fff',
          borderRadius: '16px',
        }}>
        <Box
          py={3}
          px={3}
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            borderRadius: '8px',
            boxSizing: 'border-box',
          }}>
          <Typography
            variant="h5"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              marginBottom: '2rem',
              color: '#fff',
              fontFamily: 'Space Grotesk, sans-serif',
            }}>
            Add new token
          </Typography>
          <div className="propertyContainer">
            <SettingTitle title="Token name:" />
            <ModalInputField value={tokenName} onChange={setTokenName} />
          </div>
          <div className="propertyContainer">
            <SettingTitle title="Contract address:" />
            <ModalInputField value={tokenIdentifier} onChange={setContractAddress} />
          </div>
          <Box
            mt={2}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              width: '100%',
              gap: '40px',
            }}>
            <Button name="Cancel" size="M" onClick={toggleAddTokenModal} type="secondary" />
            <Button
              name="Add token"
              disabled={isLoading || !tokenName || !tokenIdentifier}
              size="M"
              onClick={handleAddToken}
              type="primary"
            />
          </Box>
        </Box>
      </Card>
    </Modal>
  )
}
